var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "fileBoxComponentBox width-100 m-t-24",
      class: _vm.uploaderBtnShow ? "" : "fileBoxComponentBoxView",
    },
    [
      _c(
        "div",
        { staticClass: "image-files-container width-100" },
        _vm._l(_vm.imageFiles, function (item, index) {
          return _c(
            "div",
            {
              key: "img-" + index,
              staticClass: "fileItem m-b-8",
              on: {
                click: function ($event) {
                  return _vm.handleFileClick(item)
                },
              },
            },
            [
              _vm.getFileType(item.name) == "image"
                ? _c(
                    "div",
                    {
                      staticClass: "fileContainer rela",
                      class: (index + 1) % 2 === 0 ? "" : "m-r-6",
                    },
                    [
                      _c("van-image", {
                        attrs: {
                          width: "100%",
                          height: "100%",
                          fit: "cover",
                          src: item.fileURL || item.previewUrl,
                        },
                      }),
                      !_vm.disabled
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "absolute pos-t-0 pos-r-0 filesColse",
                            },
                            [
                              _c("van-icon", {
                                attrs: {
                                  name: "cross",
                                  size: "16",
                                  color: "#ffffff",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.filesColse(item)
                                  },
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          )
        }),
        0
      ),
      _c(
        "div",
        { staticClass: "other-files-container width-100 font-30" },
        _vm._l(_vm.otherFiles, function (item, index) {
          return _c(
            "div",
            {
              key: "other-" + index,
              staticClass: "fileItem other-file-item width-100",
              on: {
                click: function ($event) {
                  return _vm.handleFileClick(item)
                },
              },
            },
            [
              _c(
                "div",
                {
                  class: _vm.disabled
                    ? "other-file-content other-file-content-bai"
                    : "other-file-content",
                },
                [
                  _c("div", { staticClass: "fileNameBox" }, [
                    _vm._v(_vm._s(_vm.getFileDisplayName(item.name))),
                  ]),
                  _c("div", [_vm._v(_vm._s("." + item.fileType))]),
                ]
              ),
              !_vm.disabled
                ? _c("van-icon", {
                    staticClass: "m-l-12",
                    attrs: { name: "clear" },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.filesColse(item)
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        }),
        0
      ),
      _c("van-image-preview", {
        attrs: {
          images: _vm.currentImageList,
          "start-position": _vm.currentImageIndex,
        },
        on: { change: _vm.onImageChange },
        model: {
          value: _vm.showImagePreview,
          callback: function ($$v) {
            _vm.showImagePreview = $$v
          },
          expression: "showImagePreview",
        },
      }),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showPdfPreview,
              expression: "showPdfPreview",
            },
          ],
          staticClass: "pdfPreviewContainer",
        },
        [
          _c("iframe", {
            attrs: { src: _vm.currentPdfUrl, frameborder: "0" },
            on: { load: _vm.onPdfLoaded },
          }),
        ]
      ),
      _c(
        "van-popup",
        {
          staticClass: "filePreviewStyle",
          style: { height: "90%", width: "100%", bottom: "0" },
          attrs: { position: "bottom", round: "", closeable: "" },
          on: { close: _vm.closeOfficePreview },
          model: {
            value: _vm.showOfficePreview,
            callback: function ($$v) {
              _vm.showOfficePreview = $$v
            },
            expression: "showOfficePreview",
          },
        },
        [
          _c("div", { staticClass: "title font-28 cor-33 p-24 text-center" }, [
            _vm._v(_vm._s(_vm.selectedFile ? _vm.selectedFile.name : "")),
          ]),
          _c("div", { staticClass: "officePreviewContainer" }, [
            _c("iframe", {
              attrs: { src: _vm.currentOfficeUrl, frameborder: "0" },
            }),
          ]),
        ]
      ),
      _c("van-action-sheet", {
        attrs: { actions: _vm.downloadActions, "cancel-text": "取消" },
        on: { select: _vm.onDownloadSelect },
        model: {
          value: _vm.showDownloadSheet,
          callback: function ($$v) {
            _vm.showDownloadSheet = $$v
          },
          expression: "showDownloadSheet",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }